import * as React from "react";
import { Button, Dropdown, Form } from "react-bootstrap";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import OutsideClickHandler from "react-outside-click-handler";
import profile from "../Assets/Images/profile.png";
import { EntityManagementService } from "../../../Common/Services/EntityManagementService";
import { request } from "http";
import { resolve, reject } from "q";
import { Utils } from "../../../Common/Utilis";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { IAddLocationType } from "../../../Common/Contracts/IFacilities";
import { confirmAlert } from "react-confirm-alert";
import Instense from "../../../Common/Services/Axios-config";


export class CAType extends React.Component<any, any> {
  private inputElement: any;
  private dropdownMenuRef: any;
  constructor(props: any) {
    super(props);
    this.inputElement = React.createRef();
    this.dropdownMenuRef = React.createRef();
    this.state = {
      row: this.props?.row,
      inputValue: "",
      TypeList: this.props?.TypeList,
      filterTypeList: [],
      Type: this.props.row?.typeName,
      newType: "",
      updateType: "",
      addTypeDropdown: false,
      updateTypeDropdown: null,
      editDropdown: null,
      userClickPosition: 0,
      saved: false,
      copyTypeList: [],
      discardTableCADetails : this.props?.discardTableCADetails,
      CADetails : this.props?.CADetails
    };
    this.handleSearchType = this.handleSearchType.bind(this);
  }

  componentDidMount() {
  }

  componentDidUpdate(prevProps: any) {
    if (prevProps.row?.typeName !== this.props.row?.typeName) {
      this.setState({
        Type: this.props.row?.typeName || ""
      }, () => {
      });
    }
  }

  handleDropdownChange(item) {
    this.setState({ inputValue: "" });
    this.props.typeSelected(item, this.state.row);
  }

  handleSearchType = (e: { target: { value: string } }) => {
    this.setState({ loaderTrue: true, inputValue: e.target.value });
    let data = [...this.state.copyTypeList]
    const updatedList = data.filter(
      (item: { typeName: string }) => {
        return (
          item.typeName.toLowerCase().indexOf(e.target.value.toLowerCase()) > -1
        );
      }
    );

    this.setState({ TypeList: [] }, () => {
      this.setState({
        inputValue: e.target.value,
        loaderTrue: false,
        TypeList: updatedList,

      });
    })

  };

  getFacilityType = () => {
    if (this.props?.isGuest) {
      let storage = JSON.parse(localStorage.getItem("storage")!);
      let tenantID = storage === null ? 0 : (storage.tenantID as any);
      let request = {} as any;
      request.TenantID = tenantID;
      request.includeGuest = 1
      const url = `/EntityManagement/Get_FacilityType`;
      Instense.get(url, { params: request }).then((response) => {
        let result = response?.data?.result as any;
        this.setState({
          TypeList: result,
          copyTypeList: result
        });
      });
    } else {
    EntityManagementService.GetFacilityType()
      .then(async (result: any) => {
        let data : any [];
          data = [...result.data.result]
        this.setState({ TypeList: data, copyTypeList: data })
      })
  }
  }

  handleOpen = () => {
    this.setState({ editDropdown: null, inputValue: "", addTypeDropdown: false, saved: false, updateTypeDropdown: null, })
    this.getFacilityType()
  }

  onTypeAddClick = () => {
    this.setState({ addTypeDropdown: true, inputValue: "", newType: "", updateTypeDropdown: null, editDropdown: null, saved: false });
  }

  hideAddType = () => {
    this.setState({ addTypeDropdown: false, saved: false }, () => {
      this.handleSearchType({ target: { value: '' } });
    });
  }

  handleSaveNewType = () => {
    let request = {} as IAddLocationType;
    request.TypeName = this.state.newType;
    let TypeName = this.state.newType.trim().replace(/\s+/g, ' ');
    TypeName = TypeName.charAt(0).toUpperCase() + TypeName.slice(1);
    request.TypeName = TypeName;
    if (TypeName === "") {
      toast.error("Type name required", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "CommonArea",
      });
    }
    else {
      this.setState({ saved: true })
      EntityManagementService.AddLocationType(request)

        .then(async (result: any | null) => {
          let successToastMessage = "";
          if (result != null && result.result.messageCode === "Success") {
            this.setState({ addTypeDropdown: false });
            toast.success("Type added sucessfully", {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "CommonArea",
            });

            const addedType = {
              typeName: result.result.typeName,
              typeID: result.result.typeID,
            };
            this.getFacilityType()
            if (this.props?.locationDataUpdated) {
              this.props?.locationDataUpdated()
            }
            this.setState((prevState) => ({
              TypeList: [addedType, ...this.state.TypeList],
              Type: addedType.typeName,
              addTypeDropdown: false,
              newType: "",
              saved: false
            }), () => {
              this.handleDropdownChange(addedType);
            });



          } else {
            this.setState({ saved: false });
            // this.setState({ addTypeDropdown: false , saved : false });
            toast.error("Type already exist", {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "CommonArea",
            });
          }
          resolve();
        })
        .catch((err: any) => {
          this.setState({ saved: false });
          // this.setState({ addTypeDropdown: false , saved : false });
          Utils.toastError(
            "Type already exist",
            {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "CommonArea",
            }
          );
          reject();
        });
    }

  }

  handleSaveUpdateType = (id) => {
    let request = {} as IAddLocationType;
    request.TypeID = id;
    request.TypeName = this.state.updateType;
    let TypeName = this.state.updateType.trim().replace(/\s+/g, ' ');
    TypeName = TypeName.charAt(0).toUpperCase() + TypeName.slice(1);
    request.TypeName = TypeName;
    if (TypeName === "") {
      toast.error("Type name required", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "CommonArea",
      });
    }
    else {
      this.setState({ saved: true })
      EntityManagementService.UpdateLocationType(request)

        .then(async (result: any | null) => {
          let successToastMessage = "";
          if (result != null && result.result.messageCode === "Success") {
            this.setState({ addTypeDropdown: false });
            toast.success("Type updated sucessfully", {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "CommonArea",
            });

            const addedType = {
              typeName: result.result.typeName,
              typeID: result.result.typeID,
            };
            this.getFacilityType()
            if (this.props?.locationDataUpdated) {
              this.props?.locationDataUpdated()
            }
            this.setState({ updateTypeDropdown: false })
            this.setState((prevState) => ({
              TypeList: [...this.state.TypeList, addedType],
              Type: addedType.typeName,
              addTypeDropdown: false,
              newType: "",
              editDropdown: null,
              saved: false
            }), () => {
              this.handleDropdownChange(addedType);
            });


          } else {
            this.setState({ addTypeDropdown: false, editDropdown: null, saved: false });
            toast.error("Type already exist", {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "CommonArea",
            });
          }
          resolve();
        })
        .catch((err: any) => {
          this.setState({ addTypeDropdown: false, editDropdown: null, saved: false });
          Utils.toastError(
            "Type already exist",
            {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "CommonArea",
            }
          );
          reject();
        });
    }
  }

  handleDelete = (item) => {
    if(this.props?.handleDelete){
      this.props?.handleDelete(true);
    }
    confirmAlert({
      title:
        "Are you sure you want to delete the type?",
      message: "",
      buttons: [
        {
          label: "No",
          onClick: () => {
            if(this.props?.handleDelete){
              this.props.handleDelete(false)
            }
           
          },
        },
        {
          label: "Yes",
          onClick: () => {
            this.deleteType(item);
            if(this.props?.handleDelete){
              this.props.handleDelete(false)
            }
          },
        },
      ],
      closeOnEscape: false,
      closeOnClickOutside: false,
      overlayClassName: "rooms-alert",
    });
  };

  updatedTypeProps = (data) => {
    this.setState({discardTableCADetails : data})
  }
  

  checkConfirmDelete = (item) => {
    let mapped = this.state.discardTableCADetails.some(
      (detail) => detail.typeName?.trim().toLowerCase() === item.typeName?.trim().toLowerCase()
    );
  if(mapped)
  {
    this.handleDeleteConfirm()
  }
  else
  {
      this.handleDelete(item)
  }
}

  handleDeleteConfirm = () => {
    confirmAlert({
      title:
        "This Type is still mapped to a location. Please unmap it before proceeding with deletion",
      message: "",
      buttons: [
        {
          label: "Ok",
          onClick: () => { },
        }
      ],
      closeOnEscape: false,
      closeOnClickOutside: false,
      overlayClassName: "rooms-alert",
    });
    this.setState({ editDropdown: false })
  };


  deleteType = (item) => {
    let id = item.typeID
    if (item.typeName === this.state.Type) {
      item.typeName = "";
      item.typeID = 0;
      item.deleted = true;
      this.setState({ Type: "" })
      this.handleDropdownChange(item)
    }
    EntityManagementService.DeleteLocationType(id)
      .then(async (result: any | null) => {
        let successToastMessage = "";
        if (result != null && result.messageCode === "Success") {
          toast.success("Type deleted sucessfully", {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "CommonArea",
          });
          this.handleOpen();
          if (this.state.Type === "" && this.props.handleCASave) {
            this.props.handleCASave();
          }
          if (this.props?.locationDataUpdated) {
            this.props?.locationDataUpdated()
          }
          this.setState({ editDropdown: null });
        } else {
          this.setState({ addTypeDropdown: false });
          toast.error("Not Deleted", {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "CommonArea",
          });
          this.setState({ editDropdown: null });
        }
        resolve();
      })
      .catch((err: any) => {
        Utils.toastError(
          "Type already exist",
          {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "CommonArea",
          }
        );
        reject();
      });
  }


  handleRename = (id: number) => {
    const type = this.state.TypeList.find(
      (item: { typeID: number }) => item.typeID === id
    );
    this.setState({
      updateTypeDropdown: id,
      updateType: type ? type.typeName : "",
      inputValue: "",
      editDropdown: false,
      saved: false
    });
  };


  showDropdown = (e, id) => {
    e.preventDefault();
    e.stopPropagation();
    const tripleDotElement = e.target;
    const dropdownMenuElement = this.dropdownMenuRef.current;
    const elementRect = tripleDotElement.getBoundingClientRect();
    const menuRect = dropdownMenuElement.getBoundingClientRect();
    const offsetValue = elementRect.top - menuRect.top + dropdownMenuElement.scrollTop;
    this.setState({ editDropdown: id, userClickPosition: offsetValue });
  }

  hideRenameBox = () => {
    this.setState({ updateTypeDropdown: null, saved: false }, () => {
      this.handleSearchType({ target: { value: '' } });
    });
  }

  hideDropdown = () => {
    $(".edit-dropdown").hide();
  }

  deleteVisibility = (data) => {
    this.setState({CADetails : data});
  }


  
  render() {
    return (

      <div className="subtype-wrapper">
        <Dropdown
          className="subtype-dropdown position-static"
          onToggle={(isOpen) => {
            if (isOpen) {
              this.handleOpen();
            }
          }}
        >
          <Dropdown.Toggle
            id="dropdown-importFrom"
            className={this.props.row.typeValidation ? "alert-danger" : ""}
            style={{ border: `${this.props.locationtypeError !== "" && this.props.typeNameError !== "Guest" && this.props.isAddLocationComponent === true && this.props?.locationtypeError !== "Note: Guest Room type cannot be changed after creation" ? "#b12a18 1px solid" : ""}` }}
          >
            {/* <div className="btn-text"> */}
            {/* <EllipsisWithTooltip placement="bottom"> {this.state.Type || "Select Type"}</EllipsisWithTooltip> */}
            <div className={`btn-text`} style={{ color: `${this.props.locationtypeError !== "" && this.props.typeNameError !== "Guest" && this.props.isAddLocationComponent === true && this.props?.locationtypeError !== "Note: Guest Room type cannot be changed after creation" ? "#b12a18" : ""}` }}>
              <EllipsisWithTooltip placement="bottom">
                {this.state.Type || "Select Type"}
              </EllipsisWithTooltip>
            </div>
            {/* </div> */}
          </Dropdown.Toggle>
          <Dropdown.Menu ref={this.dropdownMenuRef}
          onWheel={(e) => e.stopPropagation() }
          >
            <div className="dropdown-content">
              <div className="search-sec">
                <input
                  type="text"
                  className="form-control"
                  onChange={this.handleSearchType}
                  placeholder="Search Type"
                  value={this.state.inputValue}
                  ref={this.inputElement}
                />
              </div>
              <div className="menu"
                onWheel={this.hideDropdown}
              >
                {this.state.TypeList?.length > 0 ? (
                  this.state.TypeList.map((item: any) => {
                    const isDeletable = !this.state.CADetails?.some((detail: any) => detail.typeName.toLowerCase() === item.typeName.toLowerCase());
                    return (
                    <Dropdown.Item
                      onClick={() => this.handleDropdownChange(item)}
                      key={item.id}
                    >
                      <div className="d-flex align-items-center justify-content-between" style={{ flex: 1 }}>
                        <div className="type-name">
                          <EllipsisWithTooltip placement="bottom">{item.typeName}</EllipsisWithTooltip>
                        </div>
                        {item.tenantid !== -1 && this.props?.typeofPage === "CommonArea" && (
                          <button onClick={(e) => this.showDropdown(e, item.typeID)}>
                            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"></path></svg>
                          </button>
                        )}
                      </div>
                      {this.state.editDropdown === item.typeID && this.props?.typeofPage === "CommonArea" && (
                        <div className="edit-dropdown"
                          style={{ top: (this.state.userClickPosition) + "px" }}
                        >
                          <div className="edit-menu"
                          // style={{ top: (userClickPosition - 80) + "px"}}
                          >
                            <div className="item">
                              <Button
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  this.handleRename(item.typeID);
                                }}
                              >
                                Rename
                              </Button>
                            </div>
                            {isDeletable && (
                            <div className="item">
                              <Button className="delete-btn"
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  this.checkConfirmDelete(item);
                                }}
                              >
                                Delete
                              </Button>
                            </div>)}
                          </div>
                        </div>
                      )
                      }

                    </Dropdown.Item>
                    )
                  })
                ) : (
                  this.state.inputValue !== "" ?
                    <Dropdown.Item style={{ pointerEvents: "none" }}>No Type match your current filters.</Dropdown.Item>
                    :
                    <Dropdown.Item style={{ pointerEvents: "none" }}></Dropdown.Item>
                )}
              </div>
              {this.props?.typeofPage === "CommonArea" &&
                <Button className="add-subtype" onClick={this.onTypeAddClick}>Add Type</Button>
              }

              {/* Add subtype dropdown */}
              {
                this.state.addTypeDropdown &&
                <OutsideClickHandler onOutsideClick={() => this.setState({ addTypeDropdown: false })}>
                  <div className="edit-dashboard-dropdown">
                    <div className="d-flex align-items-center dropdown-header">
                      <button
                        onClick={this.hideAddType}
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10" fill="none">
                          <path d="M5.49961 0.5875C5.17461 0.2625 4.64961 0.2625 4.32461 0.5875L0.499609 4.4125C0.174609 4.7375 0.174609 5.2625 0.499609 5.5875L4.32461 9.4125C4.64961 9.7375 5.17461 9.7375 5.49961 9.4125C5.82461 9.0875 5.82461 8.5625 5.49961 8.2375L2.26628 4.99583L5.49961 1.7625C5.82461 1.4375 5.81628 0.904167 5.49961 0.5875Z" fill="#2CAF92" />
                        </svg>
                      </button>
                      <h4>Add Type</h4>
                    </div>
                    <div>
                      <div className="dropdown-body">
                        <Form>
                          <Form.Group controlId="subtype">
                            {/* <Form.Label>Label</Form.Label> */}
                            <div>
                              <Form.Control
                                type="text"
                                placeholder="Enter value"
                                value={this.state.newType}
                                onChange={(e) => this.setState({ newType: e.target.value })}
                                autoComplete="off"
                                maxLength={100}
                              />
                            </div>
                          </Form.Group>
                        </Form>
                      </div>
                      <div className="d-flex justify-content-end footer">
                        <Button variant="outline"
                          onClick={this.hideAddType}
                        //tabIndex={3}
                        >
                          Cancel
                        </Button>
                        <Button
                          onClick={this.handleSaveNewType}
                          className="ms-2"
                          //tabIndex={4} 
                          disabled={this.state.saved}>
                          Save
                        </Button>
                      </div>
                    </div>
                  </div>
                </OutsideClickHandler>
              }

              {this.state.TypeList.map((item: any) => (
                this.state.updateTypeDropdown === item.typeID && (
                  <OutsideClickHandler onOutsideClick={() => this.setState({ updateTypeDropdown: false })}>
                    <div className="edit-dashboard-dropdown">
                      <div className="d-flex align-items-center dropdown-header">
                        <button
                          onClick={this.hideRenameBox}
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10" fill="none">
                            <path d="M5.49961 0.5875C5.17461 0.2625 4.64961 0.2625 4.32461 0.5875L0.499609 4.4125C0.174609 4.7375 0.174609 5.2625 0.499609 5.5875L4.32461 9.4125C4.64961 9.7375 5.17461 9.7375 5.49961 9.4125C5.82461 9.0875 5.82461 8.5625 5.49961 8.2375L2.26628 4.99583L5.49961 1.7625C5.82461 1.4375 5.81628 0.904167 5.49961 0.5875Z" fill="#2CAF92" />
                          </svg>
                        </button>
                        <h4>Rename Type</h4>
                      </div>
                      <div>
                        <div className="dropdown-body">
                          <Form>
                            <Form.Group controlId="subtype">
                              {/* <Form.Label>Label</Form.Label> */}
                              <div>
                                <Form.Control
                                  type="text"
                                  placeholder="Enter value"
                                  value={this.state.updateType}
                                  onChange={(e) => {
                                    e.stopPropagation();
                                    this.setState({ updateType: e.target.value });
                                  }}
                                  autoComplete="off"
                                  maxLength={100}
                                />

                              </div>
                            </Form.Group>
                          </Form>
                        </div>
                        <div className="d-flex justify-content-end footer">
                          <Button variant="outline"
                            onClick={this.hideRenameBox}
                          //tabIndex={3}
                          >
                            Cancel
                          </Button>


                          <Button
                            onClick={(e) => { this.handleSaveUpdateType(item.typeID) }}
                            className="ms-2"
                            //tabIndex={4} 
                            disabled={this.state.saved}>

                            Save
                          </Button>
                        </div>
                      </div>
                    </div>
                  </OutsideClickHandler>
                )))
              }
            </div>
          </Dropdown.Menu>
        </Dropdown>

      </div>
    );
    //   </OutsideClickHandler>


  }
}
